export default __webpack_public_path__ + "assets/faroe-islands-flag.png";